import { useEffect, useState } from "react";

import { Box, IconButton, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import SaveIcon from "@mui/icons-material/Save";
import MUIIcon from "../ui/MUIIcon";
import Select from "../elements/Select";

import Delete from "../elements/Delete";

const EditorToolbar = ({
  onAdd,
  onSave,
  onDelete,
  onBack,
  customOptions,
  onCustomOption,
  message,
  selectOptions,
  selectValue,
  onSelect,
}) => {
  const theme = useTheme();

  return (
    <Box
      backgroundColor={theme.palette.primary.light}
      height="30px"
      display="flex"
      alignItems="center"
      gap={1}
      paddingLeft=".5rem"
      paddingRight=".5rem"
      justifyContent="space-between"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {onBack ? (
          <IconButton onClick={onBack}>
            <ArrowCircleLeftIcon />
          </IconButton>
        ) : null}
        {onAdd ? (
          <IconButton onClick={onAdd}>
            <AddCircleIcon />
          </IconButton>
        ) : null}
        {onSave ? (
          <IconButton onClick={onSave}>
            <SaveIcon />
          </IconButton>
        ) : null}

        {Array.isArray(customOptions)
          ? customOptions.map((option) => (
              <Box>
                <IconButton onClick={() => onCustomOption(option.name)}>
                  <MUIIcon
                    name={option.iconName}
                    size="20px"
                  />
                </IconButton>
                {option.label ? (
                  <Typography
                    sx={{
                      fontSize: "6px",
                      marginTop: "-8px",
                      color: theme.palette.primary.main,
                      marginTop: "-10px",
                    }}
                    align="center"
                  >
                    {option.label}
                  </Typography>
                ) : null}
              </Box>
            ))
          : null}

        {onDelete ? (
          <Delete
            onDelete={onDelete}
            buttonPosition="right"
          />
        ) : null}
      </Box>

      <Box
        sx={{ display: "flex" }}
        gap={1}
      >
        {selectOptions && (
          <Select
            label={selectOptions.label}
            value={selectValue || ""}
            items={selectOptions.options}
            onChange={onSelect}
            labelStyle={{
              fontSize: "10px",
            }}
            controlStyle={{
              fontSize: "10px",
              width: "100px",
              "& .MuiOutlinedInput-input": {
                padding: "4px 6px",
              },
            }}
          />
        )}
        {message ? (
          <Typography sx={{ fontSize: "8px" }}>{message}</Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default EditorToolbar;
